import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Returns URLSearchParams for interacting with query parameters.
 * NOTE: for some reason `useQueryParam` hook throws an error when used in App.tsx
 */
export default function useQueryParam() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}
